module.exports = __webpack_public_path__ + "static/bmc-591a7d1bfe6fc61787eb5e4e7fb484be.png";